import _ from 'lodash'
import layoutManager from 'scoreboard/components/layout-manager'

/**
 * This is applied when we want to load all (remaining) data from the stream.
 * (e.g. during an excel export of a report)
 * Doing so saves having to do expensive DOM operations over and over which
 * is what would happen if the infinite-scroller used the default chunk size.
 */
const ALL_RESULT_CHUNK_SIZE = Number.MAX_VALUE

function onLoaded(start, view) {
	return new Promise((resolve, reject) => {
		console.log('All data loaded after', performance.now() - start, 'milliseconds')
		// // Has to be nextTick or export will get captured before reflow (#11780)
		process.nextTick(() => {
			console.log('All data visible after', performance.now() - start, 'milliseconds')
			resolve()
			// Emit this after the callback incase it does prerequisite work for exports
			view.trigger('ready') // Export will wait for this event
		})
	})
}

/**
 * If an export view uses an infinite scroller with a Chunker (stream)
 * this method should be invoked, which fires the 'ready' event when it is done.
 *
 * @param {View} view Once all of the data has been loaded
 * a 'ready' event will be triggered on this (Backbone.View) view
 * @param {boolean} view.fullyLoaded loading will stop if this is true.  Once
 * loading is complete it will update this property to true
 * @param {Chunker} stream a stream of data that may only be partially loaded
 * @param {function} [callback] If a callback function is provided the stream loader
 * will always execute and ignore layoutManager.export.  The function will
 * be invoked as soon as all of the data is loaded and added to the DOM.
 *
 */
function streamLoader(view, stream, callback) {
	if (stream && (layoutManager.export || callback)) {
		var start = performance.now()
		process.nextTick(() => {
			if (!stream.endEmitted && !view.fullyLoaded) {
				stream.on('end', () => {
					onLoaded(start, view).then(() => _.attempt(callback()))
				})
				stream.chunkSize = ALL_RESULT_CHUNK_SIZE
				stream.next()
			} else {
				onLoaded(start, view).then(() => _.attempt(callback))
			}
		})
	}
}

function streamLoaderPromise(view, stream) {
	return new Promise((resolve, reject) => {
		if (stream) {
			var start = performance.now()
			process.nextTick(() => {
				if (!stream.endEmitted && !view.fullyLoaded) {
					stream.on('end', () => resolve(onLoaded(start, view)))
					stream.chunkSize = ALL_RESULT_CHUNK_SIZE
					stream.next()
				} else {
					resolve(onLoaded(start, view))
				}
			})
		} else {
			reject('no stream was provided')
		}
	})
}

export default streamLoader
export { streamLoaderPromise }

streamLoader.__filename__ = 'components/export/stream-loader.js'
